// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"211":"727973242bb33abd","888":"21a2f62c835afc57"}[chunkId] + ".css";
};